export const departmentSettingKeys = [
  'min_day_shift_personnel_count',
  'min_night_shift_personnel_count',
  'min_weekend_shift_personnel_count',
  'min_day_shift_senior_personnel_count',
  'min_night_shift_senior_personnel_count',
  'min_weekend_shift_senior_personnel_count',
];